import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AiMonitoringService } from '../../services/monitoring.service';
import { IAuthService, IAUTHSERVICE } from '../../services/iauth.service';
import { LoginService } from '../../services/login.service';
@Component({
  selector: 'xware-nav-main',
  templateUrl: './xware-nav-main.component.html',
  styleUrls: ['./xware-nav-main.component.scss'],
})
export class xwareNavMainComponent implements OnInit {
  @Input('hideNavBar') hideNavBar: boolean;

  bNavIsOpen = true;
  bNavIsPinned = true;
  isTablet = this.isTabletCheck();
  activeTheme = '';
  isDrawer = false;
  navTheme = 'p-theme-500';
  ffs: any;
  showUserAttributes = false;
  showSignatures = sessionStorage.getItem('adType') !== 'gapi';
  homeRoute = this.showSignatures ? '/me/me-signature' : '/me/me-attributes';

  constructor(
    private breakpointObserver: BreakpointObserver,
    @Inject(IAUTHSERVICE) public authService: IAuthService,
    private router: Router,
    private aiService: AiMonitoringService,
    private loginService: LoginService
  ) {}

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  ngOnInit() {
    this.isHandset$.subscribe(result => {
      this.isDrawer = result;
      this.bNavIsPinned = true;
      this.bNavIsOpen = true;
    });
    this.navTheme = 'nav-theme';
    this.activeTheme = 'nav-theme-active';

    this.loginService.navStart
      .pipe(
        filter(status => status === 'home'),
        take(1)
      )
      .subscribe(() => {
        this.showUserAttributes = true;
      });
  }

  public isTabletCheck(): boolean {
    const uag = window.navigator.userAgent.toLowerCase();
    if (uag.indexOf('ipad') !== -1) {
      return true;
    } else {
      return false;
    }
  }

  public logout() {
    this.authService.logout();
    // this.router.navigateByUrl('/login');
    this.router.navigateByUrl(
      this.router.createUrlTree(['/login'], { queryParams: { logout: 'y' } })
    );
  }
}
